import { render, staticRenderFns } from "./ArticleHandle.vue?vue&type=template&id=e3ad04a6&scoped=true&"
import script from "./ArticleHandle.vue?vue&type=script&lang=js&"
export * from "./ArticleHandle.vue?vue&type=script&lang=js&"
import style0 from "./ArticleHandle.vue?vue&type=style&index=0&id=e3ad04a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ad04a6",
  null
  
)

export default component.exports